module.exports = __webpack_public_path__ + "static/img/BHIM.9ae0d08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/footer/img/BHIM.svg
// module id = QZRT
// module chunks = 42